import React from 'react';
import { useTranslation } from '../../hx/useTranslation';
import '../../../styles/main.css';
import CxToolbar from '../../cx/CxToolbar';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import GxLongTask from '../../gx/GxLongTask';
//import { StoreLongTask } from "../../gx/GxStore";


const MxPsListImportFileTsk = (props) => {
  const [{ trans }] = useTranslation();

  //const [storeLongTask, ] = useSessionStorage('StoreLongTask', StoreLongTask);

  React.useEffect(() => {
    formLoad();
    // eslint-disable-next-line
  }, []);

  const formLoad = async () => {
  }

  return (
    <div>
      <CxToolbar moduleName={`${trans('field.pss')}: ${trans('field.import')} - ${trans('field.task')}`} />
      <GxLongTask disable_pin_request />
    </div>
  );

}

export default MxPsListImportFileTsk;
